import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';

import { HeaderStyled, ScrollBox } from '../styles/layOutStyles';

import ThemeSwithBtn from './ThemeSwithBtn';
import ScrollTopBtn from './ScrollTopBtn';

import Topbar from './Topbar';

import { throttle } from 'lodash';

import { LayoutContext } from '../context/layoutContext';

const Header = ({ headerTitle, search, logoShow }) => {
  const { matchese } = useContext(LayoutContext);

  const headerRef = useRef();

  const [headerOpen, setHeaderOpen] = useState(false);
  const [scrollBtnOpen, setScrollBtnOpen] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', listener);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', listener);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollBtnOpen]);

  const listener = useMemo(
    () =>
      throttle(() => {
        let agent = navigator.userAgent.toLowerCase();
        if (!headerRef.current) return;
        const open = headerRef.current.clientHeight < window.scrollY;
        if (!((navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || agent.indexOf('msie') !== -1)) {
          if (scrollBtnOpen !== open) setScrollBtnOpen(open);
        }
      }, [300]),
    [scrollBtnOpen],
  );

  const handleScroll = useMemo(() => {
    if (!matchese) return;
    let ls = 0;

    return throttle(() => {
      if (!headerRef.current) return;
      let st = window.scrollY;
      let height = headerRef.current.clientHeight;

      if (st > ls) {
        setHeaderOpen(false);
      } else if (st < ls) {
        setHeaderOpen(true);
      }

      if (st < height + 10) {
        setHeaderOpen(false);
      }

      ls = st;
    }, 300);
  }, [headerOpen]);

  return (
    <React.Fragment>
      <HeaderStyled ref={headerRef} mobile={matchese} headerOpen={headerOpen}>
        <Topbar headerTitle={headerTitle} search={search} logoShow={logoShow} />
      </HeaderStyled>
      <ScrollBox>
        <ScrollTopBtn active={scrollBtnOpen} />
        <ThemeSwithBtn />
      </ScrollBox>
    </React.Fragment>
  );
};

export default React.memo(Header);
